import React from 'react'

import Form from './Form'
import Info from './Info'

import './contact-section.css'

const ContactSection = () => (
  <>
    <div className="contact-section">
      <Form />
      <Info />
    </div>
  </>
)

export default ContactSection
